export const readyMessage = 'sf iframe ready';
